import {useEffect, useState} from 'react';
import {isLoggedIn} from "../utils/authUtils";
import {getNotReadPushAlarmCount} from "../api/alarmApi";

export const useReadNotPushAlarmCount = () => {
    const [readNotCount, setReadNotCount] = useState<number>();
    const fetchReadNotCount = async () => {
        const isAuth = isLoggedIn();

        if (isAuth) {
            try {
                const response = await getNotReadPushAlarmCount();
                if (response.data?.code == "00") {
                    setReadNotCount(response.data.data > 99 ? 99 : response.data.data);
                }
            } catch (err) {
                console.error('Failed to fetch fetchWalletBalance:', err);
            }
        }
    };

    useEffect(() => {
        fetchReadNotCount();
    }, []);

    return {
        readNotCount
    }
};